export const sanitizeChatGptResponse = (rawResponse: unknown): string | null => {
  if (typeof rawResponse !== 'string') {
    return null
  }

  let text = rawResponse.trim()

  if (!text) {
    return null
  }

  const looksWrappedWithQuotes = (value: string) =>
    (value.startsWith('"') && value.endsWith('"')) || (value.startsWith("'") && value.endsWith("'"))

  if (looksWrappedWithQuotes(text)) {
    try {
      const parsed = JSON.parse(text)
      if (typeof parsed === 'string') {
        text = parsed.trim()
      } else if (parsed !== null && parsed !== undefined) {
        text = String(parsed).trim()
      } else {
        text = ''
      }
    } catch (error) {
      text = text.replace(/^"+|"+$/g, '').replace(/^'+|'+$/g, '').trim()
    }
  }

  return text || null
}
